/** Badge colours for initials avatars (product palette), used by the reviews grid. */
export const avatarColors = ['bg-grass-deep', 'bg-sky-deep', 'bg-cherry', 'bg-field-line', 'bg-grass-deep', 'bg-sky-deep']
